import { copyText } from "@/copy/copy";

/**
 * "I'm a first-time home buyer", one checkbox per adult (`Person.is_first_time_home_buyer`), as
 * onboarding's "What you owe" step and Update Data's "What you owe" section both ask it, beside the
 * properties (asked whether or not the household owns one: owning only a cottage or a rental can
 * still leave someone a first-time buyer). Unchecked unless the household says so. Test ids are
 * `<prefix>first-time-<i>`, in the order of `adults` (you first).
 */
export type BuyerAdult = { uuid: string; givenName: string };

export function firstTimeBuyerLabel(adult: BuyerAdult, i: number): string {
  return i === 0
    ? copyText("fields.firstTimeBuyer.you")
    : copyText("fields.firstTimeBuyer.named", { name: adult.givenName.trim() || "Your partner" });
}

export function FirstTimeBuyerChecks({
  adults,
  value,
  onChange,
  prefix = "",
}: {
  adults: BuyerAdult[];
  value: Record<string, boolean>;
  onChange: (uuid: string, firstTime: boolean) => void;
  /** "ud-" in Update Data. */
  prefix?: string;
}) {
  return (
    <div className="ftbuyer" style={{ marginTop: 18 }} data-testid={`${prefix}first-time`}>
      {adults.map((a, i) => (
        <div key={a.uuid}>
          <label className="repchk">
            <input
              type="checkbox"
              checked={value[a.uuid] ?? false}
              onChange={(e) => onChange(a.uuid, e.target.checked)}
              data-testid={`${prefix}first-time-${i}`}
            />{" "}
            {firstTimeBuyerLabel(a, i)}
          </label>
        </div>
      ))}
      <p className="hint" style={{ marginTop: 6 }}>
        {copyText(
          adults.length > 1 ? "fields.firstTimeBuyer.hintCouple" : "fields.firstTimeBuyer.hint",
        )}
      </p>
    </div>
  );
}
